import { NpsReviewAdapters } from '../adapters';
import { UsersApi } from '../clients';

/**
 * A user's NPS answers, mapped for the profile's NPS tab. The fetch is in
 * `clients` and the mapping in `adapters`; this is the seam the use case calls.
 * Failures propagate so the tab can show its own error state.
 *
 * @param {string} userId - the profile's user id (the registermodel id)
 * @returns {Promise<import('../types/NpsReview').INpsReviewRow[]>}
 */
export const getNpsReviews = async (userId) => {
  const response = await UsersApi.getNpsReviews(userId);

  return NpsReviewAdapters.toNpsReviewRows(response);
};
